// WebKit can emit a spurious CSS-preload `vite:preloadError` that rejects the
// dynamic import and blank-pages production (31 Jul finding). ONLY that CSS
// case is swallowed — preventDefault stops the throw and nothing else happens:
// the spurious WebKit case has zero impact, and a genuine mid-deploy CSS miss
// at worst leaves one lazy route missing styles until the next navigation
// (accepted — the static App import removed the boot-path exposure).
// JS-chunk failures ride the SAME event (vite's preload helper wraps the
// module import itself) and must propagate untouched — lazyWithRetry's backoff
// ladder + the chunk error boundary own that recovery, and preventDefault
// would make the failed import resolve `undefined` instead.
export const installPreloadErrorGuard = () => {
  window.addEventListener('vite:preloadError', (event) => {
    const message = (event as { payload?: Error }).payload?.message ?? '';
    if (!message.includes('Unable to preload CSS')) return;
    event.preventDefault();
  });
};
